import React from "react";

const SectionDivider = ({ label = "Section", className = "", isMandatory = false, width }) => {
  return (
    <div className={`flex items-center py-2.5 gap-2.5 ${className} `}>
      <p className="text-[#969BA9] text-base font-600 font-poppins text-nowrap">
        {label} {isMandatory && <span className="text-[#EF4444]">*</span>}{" "}
      </p>
      <div className={`${width || "w-full"} border border-[#BECBD3]`}></div>
    </div>
  );
};

export default SectionDivider;
